import React, { useContext } from "react";
import useValidationInput from "./useValidationInput.js";
import { store } from "../store.js";

const useValidationForm = () => {
  const isInputValid = useValidationInput();

  const getTypeEvents = (validationData) => {
    return validationData.filter(item => item.events.includes("onSubmit") || item.events.includes("onClick") || item.events.includes("onBlur"))
  }

  
  const validationForm = (containers, errors, logs, field) => {
    
    if (!containers.metaData) return;
      containers.metaData.map(currentTool => {
        const validationData = currentTool.properties.validations
        const typeEvents = validationData && validationData.selectedValues ? getTypeEvents(validationData.selectedValues) : []
        
        if (typeEvents.length > 0 ) {
          var value = currentTool.properties.text.value
          

          switch (currentTool.type) {
            case "TextEditor":
              value = value.itemValue.currentValue
              break;
            case "DateTime":
             
              break;
            default:
              value = typeof value == "object" ? value.item : value
              break;
            }
          
          const eventResponse = isInputValid({value: value}, typeEvents);
          
          if (!eventResponse.isValid) {
            const texte = logs.filter(
              log => log.type == eventResponse.type
            ).map( log =>  log.value.replace(field, currentTool.properties.field.value))[0]
            errors.push({id:currentTool.id, value:texte,
              border: "1px solid rgb(206, 17, 38)",
              isColumn: currentTool.headerId != undefined,
              styles: {
                border:"none",

                width:currentTool.styles.width.value,
                top:currentTool.styles.top.value + parseInt(currentTool.styles.height.value.slice(0, -2)) + 1, 
                left:currentTool.styles.left.value,
                position:"absolute",
                color: "rgb(206, 17, 38)",
                fontSize: 10
              }
            })
          }
        }
        validationForm(currentTool, errors, logs, field);
    });
  };

  return validationForm;
};

export default useValidationForm;
